<template>
  <div>
    <a
      class="calendar"
      target="_blank"
      :href="
        `https://www.google.com/calendar/render?action=TEMPLATE&text=${
          video.title
        }&dates=${video.utc_year}${video.utc_month}${video.utc_day}T${
          video.utc_hour
        }${video.utc_minute}00Z/${video.utc_year}${video.utc_month}${
          video.utc_day
        }T${parseInt(video.utc_hour) + 1}${video.utc_minute}00Z&details=${
          video.description_ics
        }`
      "
    >
      <BaseIcon :name="['far', 'calendar-plus']" />
      Google
    </a>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
}
</script>
